const airxPaths = [
  "dashboard/airx",
  "notification/airx",
  "quotes/arix",
  "singleSiteQuoteResults/airx/customer",
  "singleSiteQuote/airx/customer",
  "multiSiteResults/airx/customer",
  "multiSiteManual/airx/customer",
  "singleManualQuote/airx/customer",
  "quoteLine/airx/customer",
  "quoteLine/arix",
  "customers/single",
  "vendors/single",
  "accounts/customer",
  "account/vendors",
  "user/customer",
  "user/vendor",
  "user/me",
  "user/airx",
  "user/airx/customer/vendor",
  "register/newUser",
  "roles/permissions",
  "account/airx",
  "account/permissions",
  "documents/airx",
  "buildings",
  "priceList/airx",
  "company/register",
  "services/airx",
];
export default airxPaths;
